import { create } from "apisauce";
import appconfig from "../config/appconfig";
import { Cookies  } from 'react-cookie';

const apimClient = create({ 
   baseURL: appconfig.baseurl  
});

apimClient.addAsyncRequestTransform(async (request) => {
   let cookies = new Cookies();  
   if (!cookies.get("user")) return; 
   const authToken = cookies.get("user").token;
   if (!authToken) return; 
   request.headers["Authorization"] ="Bearer "+authToken;     
});

const mapStateToProps = state => {
   return {
       Auth: state.Auth,
   };
};

export default apimClient;
